var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import InternalRouter from 'navigation/pages/InternalRouter';
import scroll from 'core/scroll';
import store from 'store';
import Filters from 'sections/filters/Filters';
import PageHeader from 'components/page-header/PageHeader';
import Footer from 'components/footer/Footer';
import sizeStore from 'store/sizeStore';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import anime from 'animejs';
import { frameToMs } from 'helpers/easings';
import { defer } from 'lodash-es';
import CatalogFooter from 'components/catalog/seo-footer/SEOFooter';
import browser from 'helpers/browser';
import CategoryProducts from './partials/CategoryProducts';
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        Object.defineProperty(_this, "isSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "onPageUpdate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (page) {
                var _a;
                (_a = _this.modules.content.currentPage) === null || _a === void 0 ? void 0 : _a.resetScroll();
            }
        });
        Object.defineProperty(_this, "restore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                (_a = _this.modules.content.currentPage) === null || _a === void 0 ? void 0 : _a.restore();
            }
        });
        Object.defineProperty(_this, "resetScroll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                browser.waitRepaint(function () { var _a; return (_a = _this.modules.content.currentPage) === null || _a === void 0 ? void 0 : _a.resetScroll(); });
            }
        });
        return _this;
    }
    Object.defineProperty(Category.prototype, "getModulesMap", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __assign(__assign({}, _super.prototype.getModulesMap.call(this)), { footer: ['footer', Footer], filters: ['.filters', Filters], pageHeader: ['.page-header', PageHeader], seoLinks: ['.seo-footer', CatalogFooter] });
        }
    });
    Object.defineProperty(Category.prototype, "show", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (previousPage) {
            return __awaiter(this, void 0, void 0, function () {
                var lastCategories, backup, delay;
                var _this = this;
                return __generator(this, function (_a) {
                    this.resize();
                    this.el.style.opacity = '0';
                    lastCategories = store.lastCategories.get();
                    backup = lastCategories.find(function (s) {
                        var _a;
                        return s.id === _this.modules.content.currentPage.el.dataset.id && s.stateIdx === ((_a = window.history.state) === null || _a === void 0 ? void 0 : _a.idx);
                    });
                    delay = previousPage ? 10 : 0;
                    if (previousPage === 'Product' || previousPage === 'Category' || backup) {
                        scroll.unlock();
                        return [2 /*return*/, Promise.resolve()
                                .then(function () {
                                browser.waitRepaint(function () {
                                    _this.el.style.opacity = '1';
                                    return Promise.resolve();
                                });
                            })
                                .then(function () {
                                scroll.unlock();
                                _this.el.style.transform = '';
                                defer(function () { return _this.resize(); });
                            })];
                    }
                    return [2 /*return*/, Promise.resolve()
                            .then(function () { return anime({
                            targets: _this.el,
                            opacity: {
                                value: [0, 1],
                                duration: frameToMs(7.5),
                                delay: delay,
                                easing: 'linear'
                            },
                            delay: delay,
                            changeBegin: function () { return _this.showChildren(); }
                        }).finished; })
                            .then(function () {
                            scroll.unlock();
                            _this.el.style.transform = '';
                            defer(function () { return _this.resize(); });
                        })];
                });
            });
        }
    });
    Object.defineProperty(Category.prototype, "askPreload", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (previousPage) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, _super.prototype.askPreload.call(this, previousPage)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(Category.prototype, "preload", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var content = this.modules.content;
            return new Promise(function (resolve) {
                var _a;
                if (!((_a = content === null || content === void 0 ? void 0 : content.state) === null || _a === void 0 ? void 0 : _a.init))
                    content.once('init', resolve);
                else
                    resolve();
            });
        }
    });
    Object.defineProperty(Category.prototype, "getPageSelector", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () { return '.category__inner'; }
    });
    Object.defineProperty(Category.prototype, "getDefaultPageClass", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            // todo fix this ts error
            return CategoryProducts;
        }
    });
    Object.defineProperty(Category.prototype, "bindEvents", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (add) {
            if (add === void 0) { add = true; }
            var emitterMethod = bindEmitterMethod(add);
            var method = bindMethod(add);
            if (this.modules.content)
                this.modules.content[emitterMethod]('shown', this.onPageUpdate);
            if (this.refs.filtersToggle)
                this.refs.filtersToggle[method]('click', this.toggleFilters);
        }
    });
    Object.defineProperty(Category.prototype, "toggleFilters", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            store.drawer.set('filters');
        }
    });
    Object.defineProperty(Category.prototype, "shouldRouteInternally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (el) {
            // add offset
            var a = el.querySelector('.category__list');
            if (!a)
                return false;
            var linkA = (a.getAttribute('data-src') || '').split('?')[0];
            var linkB = (this.modules.content.currentPage.el.querySelector('.category__list').getAttribute('data-src') || '').split('?')[0];
            return linkA === linkB;
        }
    });
    Object.defineProperty(Category.prototype, "internalRouting", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (pathName, xhr, requestOptions) {
            if (requestOptions === void 0) { requestOptions = {}; }
            var el = xhr.response;
            // Update bar count
            var c = el.querySelector('.page-header__products-count');
            if (c)
                this.refs.productsCount.textContent = c.textContent;
            // Update top for transition
            var a = el.querySelector('.category__inner');
            if (a) {
                var offset = Math.min(document.scrollingElement.scrollTop, sizeStore.notificationHeight.get());
                var top = scroll.scrollTop() - offset;
                a.style.top = top + 'px';
            }
            this.modules.content.forceRouteUpdate(pathName, xhr, requestOptions);
            return Promise.resolve();
        }
    });
    Object.defineProperty(Category, "pageName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'Category'
    });
    return Category;
}(InternalRouter));
export default Category;
